export default {
    "modal": {
        "buttons": {
            "ok": "OK",
            "cancel": "Annuler",
            "yes": "Oui",
            "no": "Non",
            "abort": "Abandonner",
            "retry": "Réessayer",
            "ignore": "Ignorer"
        },

        "confirm": {
            "title": "Confirmer"
        },
        "prompt": {
            "title": "Saississez une valeur"
        }
    }
};
